export default __webpack_public_path__ + "js/components/liveClassPurchasePage/component/BenefitScreen/close-2f300bd4fada13a7ed3a5e804a354961.svg";